import { render, staticRenderFns } from "./wipay-terminal-payment-modal.vue?vue&type=template&id=62458981&scoped=true&"
import script from "./wipay-terminal-payment-modal.ts?vue&type=script&lang=ts&"
export * from "./wipay-terminal-payment-modal.ts?vue&type=script&lang=ts&"
import style0 from "./wipay-terminal-payment-modal.scss?vue&type=style&index=0&id=62458981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62458981",
  null
  
)

export default component.exports